import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { subscribeLearnerChanges } from '../services/learnerStorage';

/** React Query views refresh only after commit, in this tab and other tabs. */
export function useLearnerStorageChanges() {
  const client = useQueryClient();
  useEffect(() => subscribeLearnerChanges(() => {
    void client.invalidateQueries({ predicate: query =>
      ['learner-progression', 'static-progress', 'stories'].includes(String(query.queryKey[0])) });
  }), [client]);
}
